// extracted by mini-css-extract-plugin
export default {"link":"root_wallet-link-module__link___HdCPi","text":"root_wallet-link-module__text___FAIRA"};